/**
 * Cart drawer "You might also love..." — recently viewed (lifestyle images)
 * first, then curated fallbacks to fill up to MAX slots.
 */
(function () {
  var MAX = 5;
  var KEY = 'lovelab_recently_viewed';

  function imageSrc(url) {
    if (!url) return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function getRecentlyViewed() {
    if (window.LLRecentlyViewed && typeof window.LLRecentlyViewed.get === 'function') {
      return window.LLRecentlyViewed.get();
    }
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (i) { return i && i.id && i.path; }) : [];
    } catch (e) {
      return [];
    }
  }

  function handleFromUrl(url) {
    if (!url) return '';
    try {
      var path = url;
      if (url.indexOf('http') === 0) {
        path = new URL(url, window.location.origin).pathname;
      }
      var m = path.match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function cartHandles(root) {
    var set = {};
    var scope = (root && root.closest('cart-drawer')) || document.querySelector('cart-drawer') || document;
    var links = scope.querySelectorAll('a.cart-item__name, a.cart-item__link, .cart-item a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var h = handleFromUrl(links[i].getAttribute('href') || '');
      if (h) set[h] = true;
    }
    return set;
  }

  function readFallbacks(track) {
    var items = [];
    var nodes = track.querySelectorAll('[data-ll-upsell-fallback]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var img = el.querySelector('img');
      items.push({
        id: el.getAttribute('data-product-handle') || handleFromUrl(el.getAttribute('href') || ''),
        name: el.getAttribute('data-ll-upsell-name') || (img && img.alt) || el.textContent.trim(),
        path: el.getAttribute('href') || '',
        image: (img && (img.getAttribute('src') || img.currentSrc)) || '',
      });
    }
    return items;
  }

  function buildItem(product) {
    var a = document.createElement('a');
    a.href = product.path;
    a.className = 'll-cart-upsells__item';
    a.setAttribute('data-product-handle', product.id || '');
    a.addEventListener('click', function () {
      var drawer = a.closest('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
    });

    var thumb = document.createElement('span');
    thumb.className = 'll-cart-upsells__thumb';
    var img = document.createElement('img');
    img.src = imageSrc(product.image);
    img.alt = product.name || '';
    img.loading = 'lazy';
    img.width = 80;
    img.height = 80;
    img.addEventListener('error', function () {
      img.style.display = 'none';
    });
    thumb.appendChild(img);

    var name = document.createElement('span');
    name.className = 'll-cart-upsells__name';
    name.textContent = product.name || '';

    a.appendChild(thumb);
    a.appendChild(name);
    return a;
  }

  function hydrate(root) {
    var track = root.querySelector('.ll-cart-upsells__track');
    if (!track) return;

    var inCart = cartHandles(root);
    var seen = {};
    var selected = [];

    getRecentlyViewed().forEach(function (item) {
      if (!item || !item.id || !item.path || !item.image) return;
      if (inCart[item.id] || seen[item.id]) return;
      seen[item.id] = true;
      selected.push({
        id: item.id,
        name: item.name || item.id,
        path: item.path,
        image: item.image,
      });
    });

    readFallbacks(track).forEach(function (item) {
      if (selected.length >= MAX) return;
      if (!item.id || !item.path || !item.image) return;
      if (inCart[item.id] || seen[item.id]) return;
      seen[item.id] = true;
      selected.push(item);
    });

    selected = selected.slice(0, MAX);
    if (!selected.length) return;

    track.innerHTML = '';
    selected.forEach(function (product) {
      track.appendChild(buildItem(product));
    });
    root.setAttribute('data-ll-upsells-ready', '1');
  }

  function hydrateAll() {
    document.querySelectorAll('[data-ll-cart-upsells]').forEach(hydrate);
  }

  function bindDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.llUpsellsBound === '1') return;
    drawer.dataset.llUpsellsBound = '1';

    var origOpen = drawer.open;
    if (typeof origOpen === 'function') {
      drawer.open = function () {
        var result = origOpen.apply(this, arguments);
        // Section HTML may have just been swapped — hydrate after paint
        setTimeout(hydrateAll, 0);
        return result;
      };
    }

    drawer.addEventListener('ll:cart-drawer:updated', hydrateAll);
  }

  function init() {
    bindDrawer();
    hydrateAll();
  }

  window.LLCartUpsells = { refresh: hydrateAll, init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
